<template>
    <div class="bg-gray-100 rounded-[30px] px-5 py-6 sm:px-6 md:px-8">
        <div v-for="(category, cIndex) in categories" :key="`faq-category-${cIndex}`" class="mb-4 last:mb-0">
            <button
                type="button"
                class="w-full flex items-center justify-between gap-4 py-2 text-left"
                @click="toggleCategory(cIndex)"
            >
                <span class="font-bold">{{ category.title }}</span>
                <i
                    class="pi pi-chevron-down text-blue-700 flex-shrink-0 transition-transform"
                    :class="{ '-rotate-180': isCategoryOpen(cIndex) }"
                ></i>
            </button>

            <transition @enter="enter" @after-enter="afterEnter" @leave="leave">
                <div v-show="isCategoryOpen(cIndex)" class="faq-collapse">
                    <div class="flex flex-col gap-2 mt-2">
                        <div
                            v-for="(item, iIndex) in category.items"
                            :key="`faq-item-${cIndex}-${iIndex}`"
                            class="bg-white rounded-2xl"
                        >
                            <button
                                type="button"
                                class="w-full flex items-center justify-between gap-4 text-left pl-6 pr-4 py-4"
                                @click="toggleItem(cIndex, iIndex)"
                            >
                                <span class="font-bold text-sm">{{ item.question }}</span>
                                <i
                                    class="pi pi-chevron-down text-blue-700 text-sm flex-shrink-0 transition-transform"
                                    :class="{ '-rotate-180': isItemOpen(cIndex, iIndex) }"
                                ></i>
                            </button>
                            <transition @enter="enter" @after-enter="afterEnter" @leave="leave">
                                <div v-show="isItemOpen(cIndex, iIndex)" class="faq-collapse">
                                    <div class="px-4 pb-4 text-sm">{{ item.answer }}</div>
                                </div>
                            </transition>
                        </div>

                        <ul v-if="category.links" class="list-disc pl-5 py-2 space-y-2">
                            <li v-for="(link, lIndex) in category.links" :key="`faq-link-${cIndex}-${lIndex}`">
                                {{ link.text }}
                                <a
                                    :href="link.href"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="font-bold underline text-blue-700"
                                >
                                    {{ link.label }}
                                </a>
                            </li>
                        </ul>

                        <p v-if="category.note" class="italic text-sm pl-6 pt-2">{{ category.note }}</p>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SectionFaq',
    props: {
        categories: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            openCategories: this.categories.reduce((acc, category, index) => {
                acc[index] = !!category.open;
                return acc;
            }, {}),
            openItems: {},
        };
    },
    methods: {
        itemKey(cIndex, iIndex) {
            return `${cIndex}-${iIndex}`;
        },
        isCategoryOpen(cIndex) {
            return !!this.openCategories[cIndex];
        },
        toggleCategory(cIndex) {
            this.$set(this.openCategories, cIndex, !this.openCategories[cIndex]);
        },
        isItemOpen(cIndex, iIndex) {
            return !!this.openItems[this.itemKey(cIndex, iIndex)];
        },
        toggleItem(cIndex, iIndex) {
            const key = this.itemKey(cIndex, iIndex);
            this.$set(this.openItems, key, !this.openItems[key]);
        },
        forceReflow(el) {
            return el.offsetHeight;
        },
        enter(el) {
            el.style.height = '0';
            this.forceReflow(el);
            el.style.transition = 'height 300ms ease-in-out';
            el.style.height = `${el.scrollHeight}px`;
        },
        afterEnter(el) {
            el.style.height = 'auto';
            el.style.transition = '';
        },
        leave(el) {
            el.style.height = `${el.scrollHeight}px`;
            this.forceReflow(el);
            el.style.transition = 'height 300ms ease-in-out';
            el.style.height = '0';
        },
    },
};
</script>

<style scoped>
.faq-collapse {
    overflow: hidden;
}
</style>
